import { gql } from "apollo-angular";

export default gql`
  mutation Login($loginInput: LoginInput!) {
    login(loginInput: $loginInput) {
      otpId
      userId
    }
  }
`;
